import React, { useMemo, useEffect, useState, useRef } from 'react';
import { Row, Col, Card, CardBody, Modal,Nav,
  NavItem,NavLink } from "reactstrap"
import classnames from "classnames"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableLoader from "../../components/Common/TableLoader"
import Axios from "../../helpers/axios_helper"

import { toast,Slide } from 'react-toastify/dist/react-toastify';
import MaterialReactTable from 'material-react-table';
import { List,Delete,Edit,ChangeCircle } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import InstructorProfileModal from "./model"
import CustomModal from "../Common/CustomModal"

const DatatableTables = () => {

  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [activeTab, setActiveTab] = useState(0)

  const selectedItem = useRef(0)
  const [modal_center, setmodal_center] = useState(false)
  const [update_homepage_visibility_modal_center, setUpdate_homepage_visibility_modal_center] = useState(false);
  const [update_status_modal_center, setUpdate_status_modal_center] = useState(false);

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    instructorFullName: 'contains',
    instructorEmail: 'contains',
    instructorContactNo: 'contains'
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });
  
  //#region Datatable

  const columns = useMemo(
    () => [
      {
        size:50,
        accessorKey: 'sl',
        header: "#SL",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: false,
        enableColumnActions:false,
        enableSorting: false
      },
      {
        accessorKey: 'instructorFullName',
        header: "Full name",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'instructorContactNo',
        header: "Contact",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'instructorEmail',
        header: "Email",
        Cell: ({ cell, row }) => (
          <Typography variant='h7'>{cell.getValue()}</Typography>
        ),
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        size:50,
        accessorKey: 'instructorIsActive',
        header: "Is Active",
        Cell: ({ cell, row }) => (
          <Col style={{minWidth:"100px"}}>
          <Typography variant='h7' id={`instructorIsActive${row.original.id}`}>{cell.getValue()==1?"Yes":"No"}</Typography>
          <Tooltip arrow placement="left" title="Change">
            <IconButton onClick={() => {
              selectedItem.current=row.original.id; setUpdate_status_modal_center(true)
              }}
              >
              <ChangeCircle />
            </IconButton>
          </Tooltip>
          </Col>
        ),
        enableColumnFilterModes: false,
        enableColumnActions:false,
        enableSorting: false
      }
    ],
    [],
  );

  const findFilterCondition = (name) => {
    var condition = '';
    if (columnFilterFns[name]) {
      condition = columnFilterFns[name];
    }
    return condition;
  }

  const fetchDataFromAPI = async (reset = false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }

    let filterQuery = '';
    let sorterQuery = '';

    if (!reset) {
      if (columnFilters.length > 0) {
        columnFilters.forEach(element => {
          if (element.id === 'invoicedate' || element.id === 'duedate') {
            // filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${AuthVerify.getDate(element.value)}`;
          }
          else {
            filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
          }
        });
      }
      if (sorting.length > 0) {
        sorting.forEach(element => {
          sorterQuery += `&sortby=${element.id}&orderby=${element.desc ? 'desc' : 'asc'}`;
        });
      }
    } else {
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    const url = `/instructorProfile/list/${activeTab}?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    // let url = `/page/list`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data);
          setRowCount(response.data.recordsTotal);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };

  useEffect(() => {
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    activeTab
  ]);

  //#endregion

  //#region Modal

  const handleCallback = (response) =>{
    selectedItem.current=0;
    setmodal_center(false);
    // loadList();
  }

  const modalCallbackStatus = async (result) =>{
    if(result){
      updateActiveStatus(selectedItem.current);
    }
    setUpdate_status_modal_center(false);
    selectedItem.current=0;
  }

  const updateActiveStatus = async (id) =>{
    window.sLoader();
    const url = `/instructorProfile/changeStatus/${id}`;
    await Axios.patch(url)
      .then(function (response) {
        if (response && response.data?.status==200) {
          // document.getElementById(`instructorIsActive${id}`).innerHTML=response.data.instructorIsActive==1?"True":"False"
          fetchDataFromAPI(true);
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            transition: Slide,
          });
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
      window.hLoader();
  }

  //#endregion
  
  return (
    <>
      <div className="page-content">

        <Breadcrumbs title="Page" breadcrumbItem="List of Instructors" />

        <Row>
          <Col className="col-12">
            <Card>
            <CardBody>
              <Nav tabs>
                <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === 0,
                      })}
                      onClick={() => {
                        setActiveTab(0)
                      }}
                    >
                      <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                      <span className="d-none d-sm-block">In-Active</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === 1,
                      })}
                      onClick={() => {
                        setActiveTab(1)
                      }}
                    >
                      <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                      <span className="d-none d-sm-block">Active</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                {true ?
                  <MaterialReactTable
                    columns={columns}
                    data={data}
                    enableColumnActions={false}
                    enableGlobalFilter={false}
                    enableColumnFilterModes
                    initialState={{
                      showColumnFilters: false
                    }}
                    manualFiltering
                    manualPagination
                    manualSorting
                    onColumnFilterFnsChange={setColumnFilterFns}
                    onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    tableInstanceRef={tableInstanceRef}
                    rowCount={rowCount}
                    enableEditing
                    state={{
                      columnFilters,
                      columnFilterFns,
                      globalFilter,
                      isLoading,
                      pagination,
                      showAlertBanner: isError,
                      showProgressBars: isRefetching,
                      sorting,
                    }}
                    positionActionsColumn="last"
                    displayColumnDefOptions={{
                      'mrt-row-actions': {
                        header: 'Action',
                      },
                    }}

                    renderRowActions={({ row, table }) => (
                      <Box sx={{ display: 'flex' }}>
                        <Tooltip arrow placement="left" title="Edit">
                          <IconButton onClick={() => {selectedItem.current=row.original.id;  setmodal_center(true)}}>
                            <Edit />
                          </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="left" title="Delete">
                          <IconButton style={{color:"red"}} onClick={() => {selectedItem.current=row.original.id; setUpdate_status_modal_center(true)}}>
                            <Delete />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    )}
                  />
                  : 
                  <TableLoader />
                }
              </CardBody>
            </Card>
          </Col>
          <Modal
            size="xl"
            isOpen={modal_center}
            centered={true}>

            <div className="modal-header">
              <h5 className="modal-title mt-0">Update Instructor</h5>
              <button
                type="button"
                onClick={handleCallback}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              > 
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{padding:"0"}}>
              <InstructorProfileModal id={selectedItem.current} handleCallback={handleCallback}/>
            </div>
          </Modal>

          <CustomModal modelShow={update_status_modal_center} handleCallback={modalCallbackStatus} bodyMsg={"Do you want to update status ?"}/>
          {/* <CustomModal modelShow={reset_modal_center} handleCallback={modalCallbackReset} bodyMsg={"New password will sent to the user through user email address."}/> */}
        </Row>
      </div>

    </>
  )
}

export default DatatableTables
